import { connect } from 'react-redux'
import ServiceEditTabs from '../../components/services/edit/ServiceEditTabs'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    steps: state.serviceEdit.steps.list,
    routeProps: ownProps.routeProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditTabs)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditTabs.ts